export const owners = {
  artifactHitCount: 'ArtifactHitCount',
  baselineUpdate: 'BaselineUpdate',
  buildsBaseline: 'BuildsBaseline',
  caseAmendingBaseline: 'CaseAmendingBaseline',
  changeCommenterName: 'ChangeCommenterName',
  comment: 'Comment',
  commentHistory: 'CommentHistory',
  jiraConfirm: 'JiraConfirm',
  jiraLogin: 'JiraLogin',
  scenarioHistory: 'ScenarioHistory',
  scenarioStatus: 'ScenarioStatus',
  statistics: 'Statistics',
  testArtifacts: 'TestArtifacts',
  testsExpected: 'TestsExpected',
  installerTestsScenarios: 'InstallerTestsScenarios',
  retriggerScenarios: 'RetriggerScenarios',
  metricsByDate: 'MetricsByDate',
  acknowledgeTests: 'AcknowledgeTests',
  verifyArtifactApplication: 'VerifyArtifactApplication',
  acknowledgeBaselineUpdate: 'AcknowledgeBaselineUpdate'
};

export const jiraConfirmTypes = {
  CCFDURATION: 'ccfDuration',
  NCFDURATION: 'ncfDuration',
  CCFHITS: 'ccfHits',
  NCFHITS: 'ncfHits',
  NCFSOURCE: 'ncfSource',
  NCFSOURCEATTRIBUTE: 'ncfSourceAttribute'
};

/// Sets which checkboxes represented by types are marked by default as true
export const getTypesChecked = (ccfNcfBuildOrder, showSources) => {
  const buildOrderTypes = Object.values(ccfNcfBuildOrder).reduce((result, r) => {
    if (r) {
      result[`${r}Hits`] = true;
    }
    return result;
  }, {});
  const result = {
    ...buildOrderTypes,
    [jiraConfirmTypes.NCFSOURCE]: showSources,
    [jiraConfirmTypes.NCFSOURCEATTRIBUTE]: showSources,
    [jiraConfirmTypes.NCFDURATION]: false,
    [jiraConfirmTypes.CCFDURATION]: false
  };
  return result;
};


// WEBPACK FOOTER //
// src/helpers/modals.js